import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { TabletOrDesktop, Mobile } from "utils/responsive";
import Layout from "components/Layout";
import Modal from "components/Modal";
import MobileExpenseFormPage from "pages/MobileExpenseFormPage";
import { hideModal } from "actions/modalActions";

/**
 * Formulario de gasto a pantalla completa (solo móvil).
 */
const MobileExpenseFormResponsive = ({ hideModal }) => (
	<>
		<TabletOrDesktop>
			<Redirect to="/expenses" />
		</TabletOrDesktop>
		<Mobile>
			<>
				<Layout
					className="page-expenses page-expense-form mobile"
					context="expenses"
				>
					<MobileExpenseFormPage />
				</Layout>
				<Modal hideModal={hideModal} />
			</>
		</Mobile>
	</>
);

export default connect(null, { hideModal })(MobileExpenseFormResponsive);
